export const SET_CURRENT_USER = 'SET_CURRENT_USER';

export const ADD_NEW_MESSAGE = 'ADD_NEW_MESSAGE';

export const ADD_NEW_REQUEST = 'ADD_NEW_REQUEST';


export const APPROVE_REQUEST = 'APPROVE_REQUEST';

export const REJECT_REQUEST = 'REJECT_REQUEST';



/** WEBPACK FOOTER **
 ** ./src/constants/actionTypes.js
 **/